import { isPlatformBrowser, NgClass } from '@angular/common';
import { Component, Inject, Input, PLATFORM_ID } from '@angular/core';
import { NgbDropdownModule, NgbOffcanvas, NgbOffcanvasModule } from '@ng-bootstrap/ng-bootstrap';
import { Router, RouterLink } from '@angular/router';
import { LocalStorageService } from '../../services/common/localstorage-service';
import { RvsfService } from '../../services/rvsf-service';
import { NotificationOffcanvas } from '../ui/notification-offcanvas/notification-offcanvas';

@Component({
  selector: 'app-header',
  imports: [NgClass, NgbDropdownModule, NgbOffcanvasModule, RouterLink],
  templateUrl: './header.html',
  styles: ``,
})
export class Header {
  @Input() type: 'default' | 'dashboard' = 'default';
  isMobileSearch: boolean = false;
  user: any = null;
  isBrowser: boolean;

  constructor(
    @Inject(PLATFORM_ID) private platformId: Object,
    private localStorageService: LocalStorageService,
    private rvsfService: RvsfService,
    private router: Router,
    private offcanvasService: NgbOffcanvas,
  ) {
    this.isBrowser = isPlatformBrowser(this.platformId);
  }

  ngOnInit() {
    if (this.isBrowser) {
      this.user = this.localStorageService.get('user');
    }
  }

  get userAvatar(): string {
    const path = this.user?.profile_picture_path;
    if (!path) return '/hero/d-img.jpg';
    return path;
  }

  // openNotifications() {
  //   this.offcanvasService.open(NotificationOffcanvas, {
  //     position: 'end',
  //     panelClass: 'notification-offcanvas-panel',
  //   });
  // }

  logout() {
    this.rvsfService.userLogout().subscribe({
      next: () => {
        this.localStorageService.remove('token');
        this.router.navigate(['/']);
      },
      error: (err) => {
      },
    });
  }
}
